import React from 'react';

const Icon = ({ width = '12', height = '12', fill = '#3F68E0', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 12 11" fill="none" {...other}>
            <path
                d="M11.171 5.314a.5.5 0 1 0 0-1h-3.5v-3.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 .5.5h4Zm-9.842.284a.533.533 0 1 0 0 1.066h3.466v3.467a.533.533 0 1 0 1.067 0v-4a.533.533 0 0 0-.533-.533h-4Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
